import styled from 'styled-components';

import THEME from '../../../../../../../constants/theme';

export const BiometricContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BiometricIdentification = styled.div`
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: ${THEME.grey};
`;

const biometricStatusColor = {
  approved: '#67AC5B',
  pending : '#96782A',
  declined: '#DA724B',
};

export const BiometricStatus = styled.span`
  display: inline-block;
  text-transform: capitalize;
  color: ${({ status }) => (biometricStatusColor[status] || '#A22127')}
`;

export const BiometricLinksContainer = styled.div`
  display: flex;
  a:not(:first-child) {
    margin-left: 16px;
  }
`;

export const BiometricLink = styled.a`
  cursor: pointer;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 24px;
  color: ${THEME.primary};
  display: flex;
  align-items: center;  
  svg {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
`;
